<template>
  <div class="login">
    <div class="middle-wrapper">
      <div class="title">
        省局药品智慧监管平台
      </div>
      <div class="login-form">
        <div class="inputForm">
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="rules"
            @submit.native.prevent
          >
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入账号"
                @keyup.enter.native="loginHandle('loginForm')"
              >
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-user-solid"
                  style="font-size: 18px;"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                :type="passwordType"
                v-model="loginForm.password"
                placeholder="请输入密码"
                @keyup.enter.native="loginHandle('loginForm')"
              >
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-lock"
                  style="font-size: 18px;"
                ></i>
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-view"
                  style="cursor: pointer;"
                  @click="_togglePasswordType"
                ></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="yanzhengma">
              <div class="check-code-wrapper">
                <div class="yanzhengma-wrapper">
                  <el-input
                    v-model="loginForm.yanzhengma"
                    @keyup.enter.native="loginHandle('loginForm')"
                    placeholder="请输入验证码"
                  >
                    <i
                      slot="prefix"
                      class="el-input__icon el-icon-adm-vertification"
                      style="font-size: 18px;"
                    ></i>
                  </el-input>
                </div>
                <div class="validate-code-wrapper">
                  <validate-code
                    ref="validate-code"
                    @change="_setCheckCode"
                  ></validate-code>
                </div>
              </div>
            </el-form-item>
            <el-form-item style="margin-bottom: 0;">
              <el-col :span="11" :offset="13">
                <el-form-item>
                  <el-button
                    type="primary"
                    class="login-btn"
                    style="width: 100%;"
                    @click="loginHandle('loginForm')"
                    >登录</el-button
                  >
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';
import ValidateCode from 'components/validate-code/validate-code';
export default {
  data() {
    var checkYanzhengma = (rule, value, callback) => {
      value = value.toUpperCase();
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else if (value !== this.checkCode) {
        callback(new Error('验证码错误'));
        this.$refs['validate-code'].draw();
      } else {
        callback();
      }
    };
    return {
      passwordType: 'password',
      checkCode: '',
      loginForm: {
        username: '',
        password: '',
        yanzhengma: ''
      },
      rules: {
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        yanzhengma: [{ validator: checkYanzhengma, trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.$util.deleteSessionStorage('login_token');
  },
  created() {},
  methods: {
    _setCheckCode(value) {
      this.checkCode = value;
    },
    _togglePasswordType() {
      if (this.passwordType === 'password') {
        this.passwordType = 'text';
      } else {
        this.passwordType = 'password';
      }
    },
    loginHandle(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$util.deleteSessionStorage('login_token');
          this.$request({
            url: 'login',
            data: {
              memberAccount: this.loginForm.username,
              memberPwd: this.$util.pwdMd5(this.loginForm.password)
            }
          }).then(res => {
            this.$util.setSessionStorage('login_token', res.token);
            this.setUserInfo(res.user);
            this.setMenus(res.menus);
            this.getProvinceList();
            this.getCityList();
            const firstPath =
              res.menus.length > 0 ? res.menus[0].children[0].path : '';
            if (!firstPath) {
              this.$alert('当前用户无任何菜单权限，请分配角色后再次登录');
              return;
            }
            this.$router.push(firstPath);
          });
        } else {
          return false;
        }
      });
    },
    ...mapMutations(['setUserInfo', 'setMenus']),
    ...mapActions(['getProvinceList', 'getCityList'])
  },
  components: {
    ValidateCode
  }
};
</script>
<style lang="stylus" scoped>
>>>.el-form-item
  margin-bottom 23px
.login
  position fixed
  left 0
  top 0
  width 100%
  height 100vh
  background url('../../components/layout/images/loginBackground.png') no-repeat
  background-size 100% 100vh
  .middle-wrapper
    position fixed
    width 80%
    top 20%
    left 10%
    .title
      font-size 40px
      text-align center
      padding-bottom 50px
      background-image -webkit-linear-gradient(#B6DDFF, #5C9CE7)
      -webkit-background-clip text
      -webkit-text-fill-color transparent
    .login-form
      position relative
      margin 0 auto
      width 600px
      height 560px
      padding 80px 120px 0 120px
      box-sizing border-box
      background url('../../components/layout/images/loginKuang.png') no-repeat
      background-size 100% 100%
      .inputForm
        .el-row
          margin-bottom 20px
          &last-child
            margin-bottom 0
          .login-btn
            width 100%
        .check-code-wrapper
          display flex
          justify-content space-between
          height 40px
          line-height 40px
          .yanzhengma-wrapper
            flex 0 1 auto
          .validate-code-wrapper
            flex 0 0 160px
            margin-left 10px
</style>
